import { jsx as _jsx } from "react/jsx-runtime";
import { Primary100Shadow } from "../fundations/effects/focusRing";
import { getBorderToken, getToggleToken, getButtonToken, getFieldToken } from "../fundations/palette/colorTokens";
export const Radio = {
    MuiRadio: {
        defaultProps: {
            size: "small",
            disableRipple: true,
            icon: /*#__PURE__*/ _jsx("span", {
                style: {
                    width: 0,
                    height: 0
                }
            }),
            checkedIcon: /*#__PURE__*/ _jsx("span", {
                style: {
                    width: 0,
                    height: 0
                }
            })
        },
        styleOverrides: {
            root: ({ theme })=>({
                    padding: 0,
                    border: `1px solid ${getBorderToken("border300", theme)}`,
                    backgroundColor: getFieldToken("field01", theme),
                    width: 16,
                    height: 16,
                    "& .MuiSvgIcon-root": {
                        visbility: "hidden",
                        fontSize: 0,
                        width: 0,
                        height: 0
                    },
                    "&.Mui-focusVisible": {
                        boxShadow: Primary100Shadow
                    },
                    "&:hover": {
                        backgroundColor: getButtonToken("buttonSecondaryHover", theme)
                    },
                    "&.Mui-checked": {
                        boxSizing: "border-box",
                        border: `4px solid ${getToggleToken("toggleSelected", theme)}`,
                        "&:hover": {
                            borderColor: getToggleToken("toggleSelectedHover", theme)
                        }
                    },
                    "&.Mui-disabled": {
                        borderColor: getBorderToken("borderDisabled", theme),
                        "&.Mui-checked": {
                            boxSizing: "border-box",
                            border: `4px solid ${getToggleToken("toggleDisabled", theme)}`
                        }
                    }
                })
        },
        variants: [
            {
                props: {
                    size: "medium"
                },
                style: ({ theme })=>({
                        width: 20,
                        height: 20,
                        "&.Mui-checked": {
                            border: `5px solid ${getToggleToken("toggleSelected", theme)}`
                        },
                        "&.Mui-disabled": {
                            "&.Mui-checked": {
                                border: `5px solid ${getToggleToken("toggleDisabled", theme)}`
                            }
                        }
                    })
            },
            {
                props: {
                    size: "small"
                },
                style: ({ theme })=>({
                        width: 16,
                        height: 16,
                        "&.Mui-checked": {
                            border: `4px solid ${getToggleToken("toggleSelected", theme)}`
                        },
                        "&.Mui-disabled": {
                            "&.Mui-checked": {
                                border: `4px solid ${getToggleToken("toggleDisabled", theme)}`
                            }
                        }
                    })
            }
        ]
    }
};

//# sourceMappingURL=Radio.js.map